import { render, staticRenderFns } from "./SquareGallery.vue?vue&type=template&id=2b5e8d1a&scoped=true"
import script from "./SquareGallery.vue?vue&type=script&lang=js"
export * from "./SquareGallery.vue?vue&type=script&lang=js"
import style0 from "./SquareGallery.vue?vue&type=style&index=0&id=2b5e8d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e8d1a",
  null
  
)

export default component.exports